import React from "react";
import AppRoutes from "./routes/AppRouter";
import { BrowserRouter } from "react-router-dom";
//toas.css
import "react-toastify/dist/ReactToastify.css";
// date picker
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import NotificationComponent from "./notification";

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <NotificationComponent />
    </BrowserRouter>
  );
}

export default App;
